import type { ReactNode } from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/Footer';
import { Seo } from '@/components/Seo';

interface LegalLayoutProps {
  title: string;
  description: string;
  path: string;
  updated: string;
  children: ReactNode;
}

export function LegalLayout({ title, description, path, updated, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Seo title={`${title} | Yaw CTV`} description={description} path={path} />
      <Header />
      <main className="flex-1">
        {/* Dark title band keeps the transparent header logo readable */}
        <section className="pt-28 sm:pt-32 pb-8 bg-navy-deep">
          <div className="container mx-auto px-5 sm:px-6 max-w-3xl">
            <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight mb-2">{title}</h1>
            <p className="text-sm text-white/60">Last updated {updated}</p>
          </div>
        </section>
        <article className="container mx-auto px-5 sm:px-6 max-w-3xl py-10 sm:py-12">
          <div className="space-y-4 text-muted-foreground leading-relaxed [&_h2]:text-foreground [&_h2]:font-semibold [&_h2]:text-lg [&_h2]:mt-8 [&_h2]:mb-2 [&_a]:text-gold hover:[&_a]:underline [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1">
            {children}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}

export default LegalLayout;
